import { SxProps, Theme } from '@mui/material';

export const headerBoxStyles: SxProps<Theme> = {
    mb: 3,
};

export const titleStyles: SxProps<Theme> = {
    fontWeight: 700,
};

export const subtitleStyles: SxProps<Theme> = {
    color: 'text.secondary',
};

export const stepBoxStyles: SxProps<Theme> = {
    mb: 4,
};

export const stepTitleStyles: SxProps<Theme> = {
    fontWeight: 600,
    mb: 1.5,
};

export const selectFieldStyles: SxProps<Theme> = {
    mb: 2,
};

/**
 * The entitlement line.
 *
 * Deliberately prominent rather than fine print: it is the one thing on this page that can
 * stop the booking, and finding out at the confirm step is worse than being told up front.
 */
export const entitlementStyles: SxProps<Theme> = {
    mb: 3,
};

export const loadingBoxStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    py: 4,
};

export const emptyStateStyles: SxProps<Theme> = {
    py: 2,
    color: 'text.secondary',
};

/** The line above the button saying this is a request, not yet a booking. */
export const requestHintStyles: SxProps<Theme> = {
    mt: 2,
    color: 'text.secondary',
    fontSize: '0.875rem',
};

export const confirmRowStyles: SxProps<Theme> = {
    display: 'flex',
    gap: 2,
    alignItems: 'center',
    flexWrap: 'wrap',
    mt: 2,
};
